"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDiscount = void 0;
const getDiscount = (premiumAndDelta, premiumAndDeltaPromo) => Math.round((1 - Number(premiumAndDeltaPromo) / Number(premiumAndDelta)) * 100);
exports.getDiscount = getDiscount;
